import { ReactElement, ReactNode } from 'react';
import Label from '../Label';
import Caption, { CaptionsUnderForm } from '../Caption';
import { ErrorMessage } from '@hookform/error-message';

type Props<T extends object> = {
  name?: keyof T | (keyof T)[];
  children?: ReactNode;
  label?: ReactNode;
  caption?: ReactNode;
  optional?: boolean;
  /** 子孫要素で label を使いたいときなどのため、このコンポーネントでは label でラップしないようにする */
  noLabelWrap?: boolean;
};

// React Hook Form を使用したコンポーネントを Storybook 上で使用すると Storybook がフリーズするため、
// このコンポーネントは Storybook のストーリーを提供しない。
// cf: https://github.com/orgs/react-hook-form/discussions/7444
const FormItem = <T extends object>({
  children,
  label,
  caption,
  name = [],
  optional,
  noLabelWrap,
}: Props<T>): ReactElement => {
  const inputs = (
    <>
      {children}
      <CaptionsUnderForm>
        {caption && <Caption>{caption}</Caption>}
        {Array.isArray(name) ? (
          name.map((n) => (
            <ErrorMessage
              key={n.toString()}
              name={n.toString()}
              render={(message) => (
                <Caption variants={['error']}>{message.message}</Caption>
              )}
            ></ErrorMessage>
          ))
        ) : (
          <ErrorMessage
            name={name.toString()}
            render={(message) => (
              <Caption variants={['error']}>{message.message}</Caption>
            )}
          ></ErrorMessage>
        )}
      </CaptionsUnderForm>
    </>
  );
  return (
    <Label
      wrapBy={noLabelWrap ? 'div' : undefined}
      optional={optional}
      inputs={inputs}
    >
      {label}
    </Label>
  );
};

export default FormItem;
